import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

const SUBTITLE_TEXT =
  "Since March, more than 260 licensed child care providers have closed in Pennsylvania, including some in counties considered child care deserts. Click on a county to see how many have permanently closed, temporarily closed, and remain open.";

const FOOTNOTE_TEXT =
  "Permanent closures as of Sept. 1. Information on temporarily closed and open programs as of Sept. 25. The state designates child care deserts based on licensed child care capacity in a county and census data on the number of children under six in need of care.";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header
            headline="Child care closures across Pennsylvania"
            subtitle={SUBTITLE_TEXT}
          />
          <Body data={data} />
          <Footer
            footnote={FOOTNOTE_TEXT}
            byline="Daniel Simmons Ritchie"
            source="Pennsylvania Department of Human Services"
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
